module.exports = __webpack_public_path__ + "static/media/voxwizard-4.1138f709.jpg";